import React, { useEffect, useState } from "react";
import { faLeftRight } from '@fortawesome/free-solid-svg-icons'
import { GoldFinderLogo } from '../branding/GoldFinderLogo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useAuth } from '../../contexts/authContext'
import { auth } from '../../firebase/firebase';
import { Link, useNavigate } from 'react-router'

function PrivacyPage() {
    const { userLoggedIn, currentUser } = useAuth()
    const navigate = useNavigate()

    return (

        <div className='container-fluid'>

            <nav class="navbar navbar-expand-lg navbar-light bg-light">
                <div class="container-fluid">
                    <a class="navbar-brand" href="/">
                        <GoldFinderLogo height={70} />
                    </a>

                    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <div style={{ marginLeft: 20 }} class="collapse navbar-collapse" id="navbarNav">
                        <ul class="navbar-nav">
                            <li class="nav-item">
                                <a class="nav-link active" aria-current="page" href="https://goldfinder.net.au/faqs">More Info</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link active" aria-current="page" href="mailto:support@goldfinder.net.au">Contact</a>
                            </li>

                        </ul>
                    </div>
                    <div class="justify-content-right">

                        {userLoggedIn
                            ? <button type="button" onClick={() => { auth.signOut().then(() => { navigate('/login') }) }} class="btn btn-outline-primary me-2">Log Out</button>
                            : <button type="button" href="/login" class="btn btn-outline-primary me-2">Login</button>}

                    </div>
                </div>
            </nav>
            <div className="container">
                <h3 className="display-2">
                   PRIVACY POLICY
                </h3>

                <div class="elementor-widget-container">
                    <p><span  >GoldFinder (“GoldFinder”, “we,” “us,” or “our”) Privacy Policy. Goldfinder provides a subscription-based web application to access publicly available data layers and other mapping features for use in Western Australia.</span></p>
                    <p><span  >By using GoldFinder, you agree to the terms of this Privacy Policy:</span></p>
                    <p>1. Data Collected (User Data) by GoldFinder:</p>
                    <p>Account details such as Name, email, and password (for authentication and security purposes)</p>
                    <p><span >GoldFinder does not store payment details such as credit card details. Payment</span><span  >&nbsp;details (e.g., credit card numbers) are securely processed by third-party payment gateways such as Stripe.</span></p>
                    <p>User created Waypoints/Placemarks and GPS track recordings</p>
                    <p>User application settings</p>
                    <p>2. Sensitive information</p>
                    <p>Is defined in the Privacy Act to include information or opinion about such things as an individual’s racial or ethnic origin, political opinions, membership of a political association, religious or philosophical beliefs, membership of a trade union or other professional body, criminal record or health information.</p>
                    <p><span  >No sensitive information is collected by GoldFinder.</span></p>
                    <p>3. How collected data is used.</p>
                    <p>For authentication purposes&nbsp;</p>
                    <p>To display user created data for the user.</p>
                    <p>4. Third-Party data sharing and processing</p>
                    <p><span  >User data is not shared with third parties except only when necessary for such purposes as external authentication services and payment gateways, etc.</span></p>
                    <p>User data will not be sold or transferred to third parties.</p>
                    <p>5. Data Security</p>
                    <p>Data is stored in a manner that reasonably protects it from misuse and loss and from unauthorised access, modification or disclosure.</p>
                    <p>Your waypoints and user recorded tracks and related data are securely stored on Goldfinder managed third party hosting services.</p>
                    <p>6. User Access to Information</p>
                    <p>Users can log into their Goldfinder account to view or update their own personal details and user data.</p>
                    <p>Permanent deletion of user created data or personal information can be requested by emailing support@goldfinder.net.au</p>
                    <p>7. Data Storage</p>
                    <p>User Data is stored for as long as the user account has an active subscription or until deletion is requested by the user.</p>
                    <p>If a user’s account is not the subject of an active subscription for a period of 12 months GoldFinder may permanently delete the user’s data.</p>
                    <p>8. Policy Updates</p>
                    <p>This Privacy Policy may be subject to change in the future. Notifications may be sent via email or our website.</p>
                    <p><span  ><br /></span></p>
                    <p><span  >Contact Us</span></p>
                    <p>Email: support@goldfinder.net.au&nbsp;<span  >or contact us on Facebook</span></p>
                    <p><span  >&nbsp;</span></p>
                    <p>Last Updated 19th March, 2025</p>
                    <div>&nbsp;</div>								</div>


            </div>
        </div>








    );
}

export default PrivacyPage;
